import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Customer } from './model/customer';
import { CustomercreateService } from './service/customercreate.service';

import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy({ checkProperties: true })
@Component({
  selector: 'app-customercreate',
  templateUrl: './customercreate.component.html',
  styleUrls: ['./customercreate.component.css']
})
export class CustomercreateComponent implements OnInit {
  @Input() createCustomer:Customer;
  @Input() fromproject:boolean;
  @Output() customerToAdd = new EventEmitter<Customer>(true);
  errorMessage:string;
  formIsValid:boolean;

  constructor(private ccsrv:CustomercreateService) { }

  ngOnInit(): void {
    this.createCustomer = new Customer;
    
  }
  onRegister(){
    //console.log(JSON.stringify(this.createCustomer));
    this.ccsrv.createCustomer(this.createCustomer).pipe(untilDestroyed(this)).subscribe(custId => {
      
      this.createCustomer.customerId = custId;
      this.customerToAdd.emit(this.createCustomer);

      //this.customercreateModal.nativeElement.click();
      
    },(error)=>{
      
      this.errorMessage = error.error;

    })
  }
  close(){
    this.customerToAdd.emit(null);
  }
  validate(){
    if(
      this.createCustomer.title &&
      this.createCustomer.description  &&
      this.createCustomer.address1  &&
      this.createCustomer.address2 &&
      this.createCustomer.city &&
      this.createCustomer.zip &&
      this.createCustomer.website 
      )
      {
      this.formIsValid = true;
    }else{
      this.formIsValid = false;
    }
  }
}
